export class Subtitle {
  public name?: string;

  constructor(
    public id: number,
    public language: string,
    public offset: number,
    public fps: number,
    public playbackSpeed: number,
    public url?: string,
    public originalUrl?: string,
    public flavor?: string,
  ) {
    /* System Compatibility */
    this.name = language;
  }

  get flavoredLabel(): string {
    return `${this.language}_${this.flavor}`;
  }
}
export const HE_LETTERS = [
  "א",
  "ב",
  "ג",
  "ד",
  "ה",
  "ו",
  "ז",
  "ח",
  "ט",
  "י",
  "כ",
  "ך",
  "ל",
  "מ",
  "נ",
  "ן",
  "ס",
  "ע",
  "פ",
  "ף",
  "צ",
  "ק",
  "",
  "ץ",
  "ר",
  "ש",
  "ת",
];
export const AR_LETTERS = [
  "ا",
  "ب",
  "پ",
  "ت",
  "ث",
  "ج",
  "چ",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "ژ",
  "ص",
  "ض",
  "ط",
  "ظ",
  "ع",
  "غ",
  "ف",
  "ق",
  "ک",
  "گ",
  "ل",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
];
export const PUNCATUATIONS = [".", ",", "!", "?", ":", ";", "-", " "];
